<template>
  <v-card>
    <v-card-title> Add image </v-card-title>
    <v-card-text>
      <v-tabs v-model="tab">
        <v-tab :disabled="uploadLoading">Link</v-tab>
        <v-tab :disabled="uploadLoading">Upload</v-tab>
      </v-tabs>

      <div v-if="tab == 0">
        <v-text-field
          placeholder="Image URL"
          class="mt-4"
          dense
          v-model="imageSrc"
          id="url"
          @change="$v.imageSrc.$touch()"
          @blur="$v.imageSrc.$touch()"
          :error-messages="imageSrcErrors"
          :disabled="uploadLoading"
          :loading="uploadLoading"
        />
      </div>
      <div v-if="tab == 1">
        <v-file-input
          type="file"
          id="up"
          ref="fileSelect"
          placeholder="Select your file"
          :accept="validate.image_broadcast.type.join()"
          persistent-hint
          :hint="'max-size: ' + validate.image_broadcast.max.toString() + 'kb'"
          class="mt-4"
          counter
          :show-size="1000"
          v-model="imageEmbedded"
          :error-messages="imageEmbeddedErrors"
          @change="$v.imageEmbedded.$touch()"
          @blur="$v.imageEmbedded.$touch()"
          :disabled="uploadLoading"
          :loading="uploadLoading"
        />
      </div>
    </v-card-text>
    <v-divider />
    <v-card-actions class="pa-4">
      <v-spacer />
      <v-btn
        @click="
          () => {
            tab == 0 ? checkDimension() : uploadFile();
          }
        "
        color="success"
        :disabled="uploadLoading"
        :loading="uploadLoading"
      >
        Add Image
      </v-btn>
      <v-btn
        @click="$emit('update:modal', false)"
        color="red"
        style="color: white"
        >Close</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { url, helpers } from 'vuelidate/lib/validators';
import { validations } from '../../store/params';
import { isEmpty } from '../../lib/helpers';

const validateIf = (prop, validator) =>
  helpers.withParams({ type: 'validatedIf', prop }, function (value, parentVm) {
    return helpers.ref(prop, this, parentVm) ? validator(value) : true;
  });

export default {
  props: ['modal'],
  mixins: [validationMixin],
  validations: {
    imageSrc: {
      required() {
        if (this.tab == 0) {
          return !isEmpty(this.imageSrc);
        }
        return true;
      },
      url: validateIf('isInsertUrl', url),
      widthHeight() {
        if (!isEmpty(this.imageDimension)) {
          return !!(
            this.imageDimension.height == validations.image_broadcast.height &&
            this.imageDimension.width == validations.image_broadcast.width
          );
        }
        return true;
      },
    },
    imageEmbedded: {
      required() {
        if (this.tab == 1) {
          return !isEmpty(this.imageEmbedded);
        }
        return true;
      },
      maxSize() {
        if (this.imageEmbedded != null) {
          return (
            this.imageEmbedded.size <= validations.image_broadcast.max * 1000
          );
        }
        return true;
      },
      fileType() {
        if (this.imageEmbedded != null) {
          return !!validations.image_broadcast.type.includes(
            this.imageEmbedded.type.toLowerCase()
          );
        }
        return true;
      },
      widthHeight() {
        if (this.imageEmbedded != null) {
          return !!(
            !isEmpty(this.imageDimension) &&
            this.imageDimension.height == validations.image_broadcast.height &&
            this.imageDimension.width == validations.image_broadcast.width
          );
        }
        return true;
      },
    },
  },
  data() {
    return {
      imageSrc: '',
      command: null,
      tab: 0,
      validate: validations,
      imageEmbedded: null,
      imageDimension: null,
      base64img: '',
    };
  },
  watch: {
    imageEmbedded: {
      handler() {
        this.checkDimension();
      },
    },
    imageSrc: {
      handler() {
        this.imageDimension = null;
      },
    },
    tab: {
      handler(val) {
        if (val == 0) {
          this.clearState();
        }
      },
    },
  },
  computed: {
    uploadLoading: {
      set(status) {
        this.$store.commit('broadcast/broadcastEmail/setOnUpload', status);
      },
      get() {
        return this.$store.state.broadcast.broadcastEmail.onUpload;
      },
    },
    uploadProgress() {
      return this.$store.state.broadcast.broadcastEmail.uploadProgress;
    },
    imageEmbeddedErrors() {
      const errors = [];
      if (!this.$v.imageEmbedded.$dirty) return errors;
      if (!this.$v.imageEmbedded.required) errors.push('Image is required');
      if (!this.$v.imageEmbedded.maxSize) {
        errors.push(
          `image max size is ${this.validate.image_broadcast.max.toString()}kb`
        );
      }
      if (!this.$v.imageEmbedded.fileType) {
        errors.push('Incorrect filetype Image File');
      }
      if (!this.$v.imageEmbedded.widthHeight) {
        errors.push(
          `Image dimension must be ${this.validate.image_broadcast.width} x ${this.validate.image_broadcast.height}`
        );
      }
      return errors;
    },
    imageSrcErrors() {
      const errors = [];
      if (!this.$v.imageSrc.$dirty) return errors;
      if (!this.$v.imageSrc.required) errors.push('Image URL is required');
      if (!this.$v.imageSrc.url) errors.push('Must be a valid URL');
      if (!this.$v.imageSrc.widthHeight) {
        errors.push(
          `Image dimension must be ${this.validate.image_broadcast.width} x ${this.validate.image_broadcast.height}`
        );
      }
      return errors;
    },
    isInsertUrl() {
      return this.tab != 1;
    },
  },
  methods: {
    checkDimension() {
      const reader = new FileReader();
      const image = new Image();
      image.onload = function () {
        this.imageDimension = { width: image.width, height: image.height };
        if (this.tab == 0) {
          this.uploadLoading = false;
          this.uploadFile();
        }
      }.bind(this);

      reader.onload = function () {
        this.imageSrc = reader.result;
      }.bind(this);

      image.onerror = function () {
        this.uploadLoading = false;
      }.bind(this);

      if (this.tab == 1 && this.imageEmbedded != null) {
        image.src = URL.createObjectURL(this.imageEmbedded);
      } else if (this.tab == 0) {
        image.src = this.imageSrc;
        this.uploadLoading = true;
      }
    },
    uploadFile() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.tab == 0) {
          this.insertImage();
          return;
        }

        const file = this.imageEmbedded;
        const formData = new FormData();

        formData.append('file', file);
        formData.append('doc_type', '0');

        this.$store
          .dispatch('broadcast/broadcastEmail/uploadImage', {
            file,
            nama: 'IMAGE',
            doc_type: 0,
          })
          .then((response) => {
            if (response != 0) {
              this.imageSrc = response.url;
              this.insertImage();
            }
          });
      }
    },
    insertImage() {
      // contoh
      // "https://source.unsplash.com/random/640x480"
      const data = {
        command: this.command,
        data: {
          src: this.imageSrc,
          alt: 'Image',
          title: 'Image',
        },
      };

      this.$emit('onConfirm', data);
      this.closeModal();
    },

    clearState() {
      this.imageSrc = '';
      this.imageEmbedded = null;
      this.imageDimension = null;
    },

    closeModal() {
      this.$emit('update:modal', false);
      this.clearState();
      this.tab = 0;
    },
  },
};
</script>
